import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SharedProject } from '../types';

@Injectable({
  providedIn: 'root',
})
export class SharedProjectService {
  public isViewingShared: Observable<boolean>;
  public projectOwnerName: Observable<string>;
  public sharedProjectId: Observable<string>;
  public sharedProject: Observable<SharedProject>;
  public currentVersionNumber: Observable<number>;

  private isViewingSharedSubject: BehaviorSubject<boolean>;
  private projectOwnerNameSubject: BehaviorSubject<string>;
  private sharedProjectIdSubject: BehaviorSubject<string>;
  private sharedProjectSubject: BehaviorSubject<SharedProject>;
  private currentVersionNumberSubject: BehaviorSubject<number>;

  constructor() {
    this.isViewingSharedSubject = new BehaviorSubject(false);
    this.projectOwnerNameSubject = new BehaviorSubject('');
    this.sharedProjectIdSubject = new BehaviorSubject('');
    this.sharedProjectSubject = new BehaviorSubject(undefined);
    this.currentVersionNumberSubject = new BehaviorSubject<number>(null);

    this.isViewingShared = this.isViewingSharedSubject.asObservable();
    this.projectOwnerName = this.projectOwnerNameSubject.asObservable();
    this.sharedProjectId = this.sharedProjectIdSubject.asObservable();
    this.sharedProject = this.sharedProjectSubject.asObservable();
    this.currentVersionNumber = this.currentVersionNumberSubject.asObservable();
  }

  public endSharedView() {
    this.isViewingSharedSubject.next(false);
    this.projectOwnerNameSubject.next(undefined);
    this.currentVersionNumberSubject.next(null);
  }

  public startSharedView() {
    this.isViewingSharedSubject.next(true);
  }

  public setProjectOwner(name: string) {
    this.projectOwnerNameSubject.next(name);
  }

  public setSharedProject(sharedProject: SharedProject): void {
    this.sharedProjectSubject.next(sharedProject);
    if (sharedProject?.versionInfo) {
      const currentVersion = sharedProject.versionInfo.find((v) => v.isCurrent);
      if (currentVersion) {
        this.setCurrentVersionNumber(currentVersion.version);
      }
    }
  }

  public setSharedProjectId(id: string) {
    this.sharedProjectIdSubject.next(id);
  }

  public setCurrentVersionNumber(versionNumber: number) {
    this.currentVersionNumberSubject.next(versionNumber);
  }
}
